import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectBaseComponent} from '../../../../../core/shared/object/mvs-object-base/object-base.component';


@Component({
    selector: 'bm-billing-area-object-component',
    templateUrl: 'bm-billing-area-object.component.html',
    standalone: false
})
export class BmBillingAreaObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {


    onObjectChanged() {

    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
        if (!this.initialized) {
            return;
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

}
